























import { Component, Vue, Prop } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue' // @ is an alias to /src
import Drawer1 from './drawer.vue'
import { TableRow } from '@/types/tenant/dataPage'
import { DrawerCom } from '../index'
import { cloneDeep } from 'lodash'
import { TableHead } from '@/types/common/tableComponent'
@Component({
  components: {
    TsTable,
    Drawer1
  }
})
export default class Home extends Vue {
  @Prop() data!: TableRow[]
  status = false;
  tableData: any = {
    data: []
    // currentPage: 1,
    // pageSize: 10,
    // total: 101
  };

  tableTitleObj = {
    title: '',
    options: {
      dropdown: false
    }
  };

  tableHead = [
    {
      type: 'first',
      propName: 'name',
      labelName: '指标名称',
      options: {
        type: 'search'
      }
    },
    {
      propName: '_valueUnit',
      labelName: '较上期',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      propName: '_ratio',
      labelName: '同比增长',

      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'asc',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]

      }
    },
    {
      propName: '_value',
      labelName: '最新数据'
    }
  ];

  // 点击表格第一列
  handleTableFirst (row: TableRow) {
    (this.$refs.drawerRef as DrawerCom).show(row)
  }

  mounted () {
    setTimeout(() => {
      this.handleChange(cloneDeep(this.data))
    }, 2000)
  }

  handleChange (data: any) {
    const _data: TableRow[] = []
    data.forEach((item: any) => {
      const { values, ratioValues, valueUnit } = item
      // 同比 值
      if (values && ratioValues) {
        _data.push({
          ...item,
          _valueUnit: ((values[values.length - 1].value / values[values.length - 2].value - 1) * 100).toFixed(2),
          _ratio: ratioValues[ratioValues.length - 1].value,
          _value: values[values.length - 1].value + '  ' + valueUnit
        })
      } else if (values) { // 值
        _data.push({
          ...item,
          _valueUnit: ((values[values.length - 1].value / values[values.length - 2].value - 1) * 100).toFixed(2),
          _ratio: null,
          _value: values[values.length - 1].value + '  ' + valueUnit
        })
      } else if (ratioValues) { // 同比
        _data.push({
          ...item,
          _valueUnit: null,
          _ratio: ratioValues[ratioValues.length - 1].value,
          _value: null
        })
      }
    })

    this.tableData.data = _data
  }

  private handleClickName (row: {}) {
    (this.$refs.drawerRef as DrawerCom).show(row)
  }

  /**
   * handleFilter 过滤处理filter
   */
  handleFilter (tags: any) {
    const form: {
         [propName: string]: string;
      } = {}

    tags.forEach((item: TableHead) => {
      switch (item.params.head.options.type) {
        case 'search':
          form[item.type] = item.params.opt.value
          break

        case 'sort':
          form.sortField = item.type
          form.direction = item.params.opt.type
          break
      }
    })

    let filters: any = cloneDeep(this.tableData.data)

    if (form.name) {
      filters = filters.filter((item: any) => item.name.includes(form.name))
    }
    const emptyValueList: any[] = []
    const valueList: any[] = []
    filters.forEach((item: any) => {
      if (item[form.sortField] !== null) {
        valueList.push(item)
      } else {
        emptyValueList.push(item)
      }
    })
    if (form.direction) {
      if (form.direction === 'asc') {
        valueList.sort((a: any, b: any) => a[form.sortField] - b[form.sortField])
      } else {
        valueList.sort((a: any, b: any) => b[form.sortField] - a[form.sortField])
      }
    }
    this.handleChange([...valueList, ...emptyValueList])
  }
}
